import { normalizeApiError } from '../api/apiError';
import { createReadAsyncThunk } from "../store/createReadAsyncThunk";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CardSubscription } from '../api/endpoints/cardSubscriptionApi';
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import { Subscription } from "../models/payment/subscription";

interface requestState {
    subscriptions: Subscription[] | null;
    deleteCardSubscriptionResponse: boolean | null;

    subscriptionsStatus: ApiRequestStatus;
    deleteSubscriptionsStatus: ApiRequestStatus;
}

const initialState: requestState = {
    subscriptions: null,
    deleteCardSubscriptionResponse: null,

    subscriptionsStatus: ApiRequestStatus.Idle,
    deleteSubscriptionsStatus: ApiRequestStatus.Idle
}

export const getCardSubscriptionAsync = createReadAsyncThunk<Subscription[]>(
    'cardSubscriptionSlice/getCardSubscriptionAsync',
    async (_, thunkAPI) => {
        try {
            return await CardSubscription.getCardSubscriptionAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const deleteCardSubscriptionAsync = createAsyncThunk<boolean, string>(
    'cardSubscriptionSlice/deleteCardSubscriptionAsync',
    async (id, thunkAPI) => {
        try {
            return await CardSubscription.deleteCardSubscriptionAsync(id);
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const cardSubscriptionSlice = createSlice({
    name: 'cardSubscriptionSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(getCardSubscriptionAsync.pending, (state) => {
            state.subscriptionsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getCardSubscriptionAsync.fulfilled, (state, action) => {
            state.subscriptions = action.payload;
            state.subscriptionsStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(getCardSubscriptionAsync.rejected, (state) => {
            state.subscriptionsStatus = ApiRequestStatus.Rejected;
        });
        
        builder.addCase(deleteCardSubscriptionAsync.pending, (state) => {
            state.deleteSubscriptionsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(deleteCardSubscriptionAsync.fulfilled, (state, action) => {
            state.deleteCardSubscriptionResponse = action.payload;
            state.deleteSubscriptionsStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(deleteCardSubscriptionAsync.rejected, (state) => {
            state.deleteSubscriptionsStatus = ApiRequestStatus.Rejected;
        });
    })
})
